import {of as observableOf,  Subject ,  Observable } from 'rxjs';

import { XAPIRunner } from 'libs-frontend-xapi/dist/js/xapirunner.js';
import { XAPIAnalytics } from 'libs-frontend-xapi/dist/js/xapianalytics.js';
import {Toc} from "../interfaces/toc";
import { AuthService } from '../../app/services/auth.service';
import { GroupHelperService } from './groups-helper.service';
import { Injectable } from '@angular/core';
import { ProductContentHelper, ContentHelper } from 'libs-content-helper';
import Raven from 'raven-js';
import { RecordingHelperService } from './recording-helper.service';
import { ContentAccessHelperService } from './content-access-helper.service';

// declare global {
//   interface Window { XAPIRunner: any; }
// }
// window.XAPIRunner = XAPIRunner;
@Injectable()
export class ActivityViewHelperService {
  selectedItemId = new Subject();
  changesNotSaved = new Subject<void>();
  pskillUrlLinkValidation = new Subject<any>();
  pskillAnsSaved:Subject<any> = new Subject<any>();
  saveAlertAction: Subject<boolean> = new Subject<boolean>();
  stopAllOtherAudiosOnPlayingOneAudio = new Subject<number>();
  closeActivitySubject = new Subject<void>();
  completeCollabActivity = new Subject();
  activityEventsSubject = new Subject<any>();
  progressBarSubject = new Subject<any>();

  private spaceId: any;
  private productCode : string;
  private isTestTypeProduct: boolean = false;
  private isAssignmentOnlyProduct = false;
  private classId : string;
  private classData: object;
  private isCBPClass: boolean = false;
  private xapiLO: any;
  private xapiLOAnalytics: any;
  private isTeacher: boolean;
  private productViewData: any;
  private initParams: any;
  private productResultsDisplayData: any = {};
  private productContentHelper: any;
  private segment: string;
  private accessRules: any = {};
  private scoreDetailFormatTypes = { mock: 'MOCK', none: 'none' };
  private productModelTypes = { test: 'TEST' };
  private activityTimings: any = {};

  constructor(
    private authService: AuthService,
    private recordingHelperService: RecordingHelperService,
    private groupHelperService: GroupHelperService,
    private contentAccessHelperService: ContentAccessHelperService
  ) { }

  setProductViewData(productViewData) {
    let targetScore = undefined;
    if (productViewData.associatedGradeScale) {
      const targetGrade = productViewData.associatedGradeScale.grades.find((grade) => {
        return grade.target;
      });
      if (targetGrade) {
        targetScore = targetGrade.min_threshold / 100;
      }
    }
  	if(productViewData.groupDetails && productViewData.groupDetails.count) {
      productViewData.groupDetails = this.groupHelperService.groupDetailsTransform(productViewData.groupDetails);
      this.groupHelperService.setGroups(productViewData.groupDetails.entities);
    }
    const scoreType = productViewData.classDetails?.analytics_score_aggregation_type === 'first' ? 'firstResult': 'bestResult';
    if( productViewData && productViewData.productDetails && productViewData.bundleDetails) {
      const productCode = productViewData.productDetails.productcode;
      const bundleProduct = productViewData.bundleDetails.products.find( (bP) => bP['dls-product']['code'] === productCode);
      if (bundleProduct && bundleProduct['results-display']) {
        this.productResultsDisplayData = bundleProduct['results-display'];
      }
      this.isTestTypeProduct = this.isTestTypeComponent(bundleProduct);
      this.productContentHelper = new ProductContentHelper(bundleProduct, this.isTestTypeProduct, targetScore, scoreType);
      this.isAssignmentOnlyProduct = bundleProduct.activation?.gated?.student?.['assignments-only'];
    }
    
    this.productViewData = this.transformTOC(productViewData);

    if (productViewData.classDetails) {
      this.classId = productViewData.classDetails.uuid;
      this.isCBPClass = productViewData.classDetails.analyticsharingmodel === 'NOINHERIT_SYNCBACK';
    }
  }

  getProductViewData() {
    return this.productViewData;
  }
  getNavigationMeta() {
    return this.productViewData.toc.navigationMeta;
  }
  getAnalyticsGroupIdOfAnItem(itemId, isCollabPskill) {
    let navigationArray = this.getNavigationMeta();
    let analyticsOfItemFound = navigationArray.find((navItem)=> navItem['item-code']===itemId).__analytics;
    let analyticsGroupId;
    if(isCollabPskill) {
      analyticsGroupId = analyticsOfItemFound && analyticsOfItemFound.evaluation && analyticsOfItemFound.evaluation.groupId;
    } else {
      analyticsGroupId = analyticsOfItemFound && analyticsOfItemFound.completed && analyticsOfItemFound.completed.groupId;
    }
    return analyticsGroupId;
  }

  setProductClass(spaceId, productCode, classId, classData) {
      this.spaceId = spaceId;
      this.productCode = productCode;
      this.classId = classId;
      this.classData = classData;
  }
  getSpace() {
    return this.spaceId;
  }
  getProductClass() {
    return this.classData;
  }
  getProduct() {
    return this.productCode;
  }

  public getIsTestTypeProduct() {
    return this.isTestTypeProduct;
  }

  public getIsAssignmentOnlyProduct() {
    return this.isAssignmentOnlyProduct;
  }

  getClass() {
    return this.classId;
  }

  public getIsCBPClass() {
    return this.isCBPClass;
  }

  setXAPIRunnerObject (initParams, eventCallbacks) {
      this.xapiLO = new XAPIRunner(initParams, eventCallbacks);
  }
  setXAPIAnalyticsObject (analyticsDataObj) {
      if (this.xapiLOAnalytics) {
        return;
    }
    let xapiLOparams = {
        serverRoutePrefix: analyticsDataObj.serverRoutePrefix,
        productCode: analyticsDataObj.dlsProductCode,
        isTestTypeProduct: analyticsDataObj.isTestTypeProduct,
        spaceId : analyticsDataObj.spaceId,
        orgId: analyticsDataObj.orgId,
        classId : analyticsDataObj.dlsClassId,
        isCBPClass: analyticsDataObj.isCBPClass,
        assignedPathId : analyticsDataObj.dlsAssignmentId,
        userDetails: { extUserId: analyticsDataObj.userId },
        userProgressAnalytics: analyticsDataObj.userProgressAnalytics,
        errorCallback: (errorSource, error) => {
          const message = `[Custom] captured failed XAPIRunner http request for ${errorSource} with status ${error.status}...`;
          Raven.captureBreadcrumb({
            message,
            category: 'xhr',
            data: error,
            level: 'error'
          });
          Raven.captureException(message);
        }
    }
    if (analyticsDataObj.persistentState) {
      xapiLOparams['persistentState'] = analyticsDataObj.persistentState;
    }

      this.xapiLOAnalytics = new XAPIAnalytics(xapiLOparams);
  }

  getXAPIRunnerObject() {
      return this.xapiLO;
  }

  getXAPIAnalyticsObject() {
      return this.xapiLOAnalytics;
  }

  setLOInitParams(initParams) {
    this.initParams = initParams;
  }

  getLOInitParams() {
    return this.initParams;
  }

  setIsTeacher(isTeacher) {
    this.isTeacher = isTeacher;
  }
  getIsTeacher() {
    return this.isTeacher;
  }
  setSegment(segment) {
    this.segment = segment;
  }
  getSegment() {
    return this.segment;
  }

  public terminateActivityView(): Observable<boolean> {
    if (this.isTeacher) {
      return observableOf(true);
    }
    return this.getXAPIAnalyticsObject().flushStateAndStatements().then((response)=> {
        return true;
    },(error)=> {
      return true;
    }).catch((error)=> {
      return true;
    });
  }

  // Transform the Toc from Array to Object
  /*
   For transforming TOC we have copied the references in tocObject, tocArray , navigationMeta Array.
   This is done to sync all the data between these data Objects i.e if data is updated in tocObject
   it will be updated in tocArray , navigationMeta as well. The cached response in ProductViewDataService
   service is also updated if the data is changed in component.
   */
  transformTOC(classProductViewData: any) {
    /* userData is needed to detrmine if user is a student, if yes then filter activities with role as teacher */
    const userData = this.authService.getUserData();
    if (classProductViewData.classDetails && userData?.role === 'student') {
      this.contentAccessHelperService.setContentAccessEnabled(true);
      this.contentAccessHelperService.setCurrentTime(classProductViewData.serverTime);
      this.contentAccessHelperService.setClassStartDate(classProductViewData.classDetails?.class?.startdate);
      this.contentAccessHelperService.setClassEndDate(classProductViewData.classDetails?.class?.enddate);

      if(classProductViewData.userAssignmentDetails && classProductViewData.userAssignmentDetails.entities) {
        const activeAssignmentDetails: any = {}; // map of itemcode and active assignment start & due date i.e {item-code: startDate, dueDate}
        const scheduledAssignmentDetails: any = {}; // map of itemcode and scheduled assignment start & due date i.e {item-code: startDate, dueDate}
        classProductViewData.userAssignmentDetails.entities.forEach(assignment => {
          if (!this.isAssignmentOnlyProduct && assignment.duedate < this.contentAccessHelperService.getCurrentTime()) {
            // In case of non-assignment-only products, skip assignments whose due date has passed
            return;
          }

          for(const item of assignment.items) {
            if (item.dls_product_code === classProductViewData.productDetails['productcode']) {
              // Store the scheduled assignment details
              if (assignment.startdate > this.contentAccessHelperService.getCurrentTime()) {
                this.addAssignmentDatesToItemsMap(scheduledAssignmentDetails, item['item-code'], assignment.startdate, assignment.duedate);
              } else if (assignment.duedate >= this.contentAccessHelperService.getCurrentTime()) {
                // Store the active assignment details
                this.addAssignmentDatesToItemsMap(activeAssignmentDetails, item['item-code'], assignment.startdate, assignment.duedate);
              }

              // For an assignment-only product, update the default lock rule details.
              this.isAssignmentOnlyProduct && this.contentAccessHelperService.updateAssignOnlyItemLockRule(item['item-code'], assignment.startdate);
            } else {
              break;
            }
          }
        });
        // Set product assignments details in the content access service
        this.contentAccessHelperService.setAssignmentDetails(activeAssignmentDetails, scheduledAssignmentDetails);
      }

      if(classProductViewData.accessRuleDetails) {
        const accessRules = classProductViewData.accessRuleDetails.entities;
        if (accessRules.length !== 0) this.accessRules = accessRules[0];
      }
    }

    let toc: Toc = {
      tocObject: {},
      tocArray: classProductViewData['toc'],
      navigationMeta: []
    };

    this.productCode = classProductViewData.productDetails['productcode'];

    let tocItemObject = {};
    const productLevelRules = this.contentAccessHelperService.collectLockUnlockRules(this.productCode, null, this.productCode, this.accessRules, this.isAssignmentOnlyProduct);

    toc.tocArray.result.forEach((obj, index) => {
      tocItemObject = this.transformItem(obj, null, toc['navigationMeta'], productLevelRules, userData.role === 'student');
      tocItemObject[obj['item-code']].index = index;
      toc['tocObject'][obj['item-code']] = tocItemObject[obj['item-code']];
    });
    classProductViewData.toc = toc;
    return classProductViewData;
  }

  // Transform particular Toc Item from Array to Object
  transformItem(object, parent, tocNavigationMeta, parentLockUnlockRules, isLearner = false) {
    object['accessInfo'] = {
      rules: { lockRules: [], unlockRules: [] },
      totalChildCount: 0,
      childLockCount: 0
    }
      let transformedOject = {};
      transformedOject[object['item-code']] = {};
      Object.keys(object).forEach((prop) => {
          transformedOject[object['item-code']][prop] = object[prop];
      });
      transformedOject[object['item-code']]['parent-name'] = parent;

      if(this.contentAccessHelperService.getContentAccessEnabled()) {
        // Collect current item lock and unlock rules
        object.accessInfo.rules = this.contentAccessHelperService.collectLockUnlockRules(object['item-code'], object['item-type'], this.productCode, this.accessRules, this.isAssignmentOnlyProduct, parentLockUnlockRules);
        transformedOject[object['item-code']].accessInfo.rules = object.accessInfo.rules;
      }

      if (object.items) {
        transformedOject[object['item-code']].items = {};
        object.items = object.items.filter((item, index) => {
          // Filter teacher only activity if student
          if ((item['item-type'] === 'resource') && (isLearner && ContentHelper.isTeacherOnlyContent(item))) {
              return false;
          }
          const parentName = (transformedOject[object['item-code']]['parent-name'] ? transformedOject[object['item-code']]['parent-name'] + ' > ' : '') + object.name;
          transformedOject[object['item-code']].items[item['item-code']] = this.transformItem(item, parentName, tocNavigationMeta, object.accessInfo.rules, isLearner)[item['item-code']];
          transformedOject[object['item-code']].items[item['item-code']].index = index;

          if(this.contentAccessHelperService.getContentAccessEnabled()) {
            object['accessInfo']['totalChildCount'] += item['item-type'] === 'resource' ? 1 : object.items[index]['accessInfo']['totalChildCount'];
            object['accessInfo']['childLockCount'] += item['item-type'] === 'resource'? +object.items[index]['accessInfo']['isLocked'] : object.items[index]['accessInfo']['childLockCount'];
          }
          return true;
        });
      }
      // if item is activity, add it to navigationMeta
      if (transformedOject[object['item-code']]['item-type'] === 'resource') {
        tocNavigationMeta.push({
          'item-code': transformedOject[object['item-code']]['item-code'],
          '__analytics': transformedOject[object['item-code']]['__analytics'],
          'sub-type': transformedOject[object['item-code']]['sub-type'],
        });
        this.productContentHelper.updateAnalyticsAsPerClassCustomisations(object);
        this.productContentHelper.updateAnalyticsAsPerClassCustomisations(transformedOject[object['item-code']]);
        transformedOject[object['item-code']].lchObject = object.lchObject = {
          iconObj : this.productContentHelper.getActivityIconForNLP(object)
        }
        if(this.contentAccessHelperService.getContentAccessEnabled()) {
          // creating deep copy of rules and merging lock and unlock rules into one
          const lockUnlockRules = this.contentAccessHelperService.mergeLockUnlockRules(JSON.parse(JSON.stringify(object.accessInfo.rules)));

          object['accessInfo']['finalResultantLockDetails'] = this.contentAccessHelperService.filterLockUnlockRules(this.contentAccessHelperService.getFinalResultantLockDetails(lockUnlockRules));
          transformedOject[object['item-code']]['accessInfo']['finalResultantLockDetails'] = object['accessInfo']['finalResultantLockDetails'];

          object['accessInfo']['isLocked'] = this.contentAccessHelperService.getCurrentActiveRule(object['accessInfo']['finalResultantLockDetails'], object['item-code'], this.isAssignmentOnlyProduct).isLocked;
        }
      }
    return transformedOject;
  }

  // Check if a given activity is complete
  isThisActivityComplete(activityObj) {
    if ( this.isTeacher) {
      return false;
    }
    return (activityObj.__analytics && activityObj.__analytics.completedOnce);
  }

  // Check if all activities in unit are complete
  isThisUnitComplete(unitCode) {
    if ( this.isTeacher) {
      return false;
    }
    const unit = this.productViewData.toc.tocArray.result.find( (u) => ( u['item-code'] === unitCode) );
    for (const lesson of unit.items) {
      if (lesson.__analytics) {
        for (const activity of lesson.items) {
          if (!this.isThisActivityComplete(activity)) {
            return false;
          }
        }
      } else {
        return false;
      }
    }
    return true;
  }

  getProductContentHelper(){
    return this.productContentHelper;
  }
  getProductResultsDisplayData() {
    return this.productResultsDisplayData;
  }

  // Return Updated signed URL if signedURL is about to expire else return empty string
  async checkExpiryAndReturnUpdatedSignedURL(signedURL, {audioDuration = undefined, fetchSignedUrlForInterBucket = false, timestampQueryParamRequired = true} = {}) {
    let isNewSignedUrlNeeded = false;
    let updatedSignedURL = '';
    const urlValidityPeriod = this.getUrlValidityPeriod(audioDuration);

    const audioURL = new URL(signedURL);
    const expiryTimestamp = this.getExpiryTimeFromSignedURL(audioURL);
    if (expiryTimestamp) {
      // current time
      const currentTimestamp = (new Date().getTime())/1000;
      const secondsLeft = expiryTimestamp - currentTimestamp;

      // Check if signed URL is about to expire i.e the difference of expiring minutes is less than the audio duration
      isNewSignedUrlNeeded = !audioDuration || (secondsLeft < audioDuration);
    } else { //in case Expire query params is not there then generate new signed URL
      isNewSignedUrlNeeded = true;
    }
    if(isNewSignedUrlNeeded){
      try {
        if (fetchSignedUrlForInterBucket) {
          const response = await this.recordingHelperService.getSignedUrlsForRecordingInInterBucket(audioURL.pathname.substring(1), urlValidityPeriod).toPromise();
          updatedSignedURL = response.signedUrl;
        } else {
          const response = await this.recordingHelperService.getSignedURL({
            url: `${audioURL.origin}${audioURL.pathname}`,
            timestampQueryParamRequired: timestampQueryParamRequired,
            urlValidityPeriod
          });
          updatedSignedURL = response.signedURL;
        }
      } catch(error) {
        return updatedSignedURL;
      }
    }
    return updatedSignedURL;
  }

  // Function to check test type product
  public isTestTypeComponent(bundleProduct = {}) {
    const resultsDisplayScoreDetailFormat = bundleProduct['results-display'] &&
      bundleProduct['results-display']['score-detail-format'] ?
        bundleProduct['results-display']['score-detail-format'] :
        this.scoreDetailFormatTypes.none;
    const productModelType = bundleProduct['ext-product'] && bundleProduct['ext-product']['model'];

    return resultsDisplayScoreDetailFormat === this.scoreDetailFormatTypes.mock ||
      productModelType === this.productModelTypes.test;
  }

  public existsActivityTiming(activityId: string) {
    return !!this.activityTimings[activityId];
  }

  public addActivityTiming(activityId: string, metric: string, ts = Date.now()) {
    if (!this.activityTimings[activityId]) {
      this.activityTimings[activityId] = {};
    }
    this.activityTimings[activityId][metric] = ts;
  }

  public getActivityTiming(activityId: string): any {
    const timingData = this.activityTimings[activityId];
    if (timingData && timingData.launchTs) {
      Object.keys(timingData).forEach(key => {
        if (key !== 'launchTs') {
          timingData[key] = timingData[key] - timingData.launchTs;
        }
      });
    }
    return timingData;
  }

  public deleteActivityTiming(activityId: string) {
    delete this.activityTimings[activityId];
  }

  updateParentChildLockCount(toc, selectedItemData) {
    const itemCode = selectedItemData['item-code'].split('/');
    const unitItemCode = itemCode[0];
    const lessonItemCode = itemCode[0] + "/" + itemCode[1];

    if (selectedItemData['accessInfo'].isLocked) {
      // increment if new state is changed to lock
      toc.tocObject[unitItemCode]['items'][lessonItemCode]['accessInfo'].childLockCount++;
      toc.tocObject[unitItemCode]['accessInfo'].childLockCount++;
    } else {
      // decrement if new state is changed to unlock
      toc.tocObject[unitItemCode]['items'][lessonItemCode]['accessInfo'].childLockCount--;
      toc.tocObject[unitItemCode]['accessInfo'].childLockCount--;
    }
  }

  /**
   * Get expiry time from the signed URL
   * The signed URL can have two types of expiry time query parameters:
   * 1. Expires query parameter (from cloudfront signed URL)
   * 2. X-Amz-Date and X-Amz-Expires query parameters (from S3 signed URL)
   * @param audioURL - Signed URL of the audio file
   * @returns - Expiry time of the signed URL in seconds
   */
  private getExpiryTimeFromSignedURL(audioURL: URL) {
    let expiryTimestamp;
    try {
      // Get query parameters
      const queryParams = new URLSearchParams(audioURL.search);
      const xAmzDate = queryParams.get('X-Amz-Date');
      const xAmzExpiry = queryParams.get('X-Amz-Expires');
      const expiry = queryParams.get('Expires');

      // Get Expiry time from signedURL
      if (expiry) {
        expiryTimestamp = expiry as any;
      } else if (xAmzDate && xAmzExpiry) {
        // Convert to standard ISO date format
        const signingIsoDate = xAmzDate.replace(
          /(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z/,
          "$1-$2-$3T$4:$5:$6Z"
        );

        const signingTime = new Date(signingIsoDate).getTime() / 1000;
        expiryTimestamp = signingTime + parseInt(xAmzExpiry);
      }

      return expiryTimestamp;
    } catch {
      return expiryTimestamp;
    }
  }

  /**
   * Get the dynamic URL validity period based on the audio duration (including 20% buffer time).
   * Minimum URL validity period is 10 seconds.
   * If no audio duration is provided, the function will return undefined (this should use the default 
   * validity period i.e. 24 minutes).
   * @param audioDuration - Audio duration in seconds
   * @returns URL validity period in seconds
   */
  public getUrlValidityPeriod(audioDuration: number) { 
    if (audioDuration)
      return (1.2 * audioDuration) > 10 ? (1.2 * audioDuration) : 10;
  }

  /** Add assignment start and due dates to the items map
   * - It merges the overlapping assignment dates for the same item code
   * 
   * Known limitation: This map stores only the details of the first non-overlapping assignment and it ignores other future assignments,
   * so if the user somehow stays beyond this stored assignment timeperiod, due to future asssignments being ignored, the user will see
   * the items as locked, if there exists a lock rule. But the item should ideally be accessible. 
   * 
   * @param itemsMap - Container of the assignment dates for each item code
   * @param itemCode - Item code
   * @param newStartDate - Start date of the new assignment
   * @param newDueDate - Due date of the new assignment
   */
  private addAssignmentDatesToItemsMap(itemsMap: any, itemCode: string, newStartDate: number, newDueDate: number) {
    if (!itemsMap[itemCode]) {
      itemsMap[itemCode] = { startDate: newStartDate, dueDate: newDueDate };
      return;
    }

    const { startDate, dueDate } = itemsMap[itemCode];

    if (startDate >= newStartDate) {
      // If the new start date is before the current start date
      itemsMap[itemCode].startDate = newStartDate;

      if (startDate > newDueDate) {
        // If start date is after new due date
        itemsMap[itemCode].dueDate = newDueDate;
      }
    }
    
    if (dueDate > newStartDate && dueDate <= newDueDate) {
      // If new start date is before current due date and new due date is after current due date
      itemsMap[itemCode].dueDate = newDueDate;
    }
  }
}
